export default "__VITE_ASSET__DDoUifJm__"